import React from 'react';
import {TextButton, TextButtonPriority} from '@wix/wix-ui-tpa/cssVars';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../Widget/ControllerContext';
import {classes} from './Header.st.css';
import {HeaderDataHooks} from './Header';
import {SPECS} from '../../../common/constants';

export const ContinueShoppingButton: React.FC = () => {
  const {
    checkoutSettingsStore,
    navigationStore: {continueShoppingUrl, clickOnContinueShopping, isContinueShoppingEnabled},
  } = useControllerProps();
  const {experiments} = useExperiments();
  const localKeys = useLocaleKeys();

  const shouldApplyHeaderCustomizations = experiments.enabled(SPECS.CheckoutHeaderAdditionalCustomizationsCheckout);
  const continueShoppingText =
    checkoutSettingsStore?.checkoutContent?.continueShoppingLink ?? localKeys.checkout.continue_shopping();

  if (!isContinueShoppingEnabled) {
    return null;
  }

  return (
    <TextButton
      as={'a'}
      className={shouldApplyHeaderCustomizations ? classes.continueShoppingButton : classes.continueShoppingButtonOld}
      data-hook={HeaderDataHooks.ContinueShoppingButton}
      href={continueShoppingUrl}
      onClick={() => clickOnContinueShopping?.()}
      priority={TextButtonPriority.link}>
      {continueShoppingText}
    </TextButton>
  );
};
